import React, { useCallback, useState, useEffect, useContext } from 'react';
import cloneDeep from 'lodash/cloneDeep';

import Modal from 'common/Modal/Modal';
import { travelDetailForm, cardViewMobileProps } from '../../config';
import { GenericDiv, GenericP, FlexDiv } from 'commonStyles';
import { Notification, CardView, TrainIcon } from '../../Style';
import DropDown from 'common/Dropdown/DropDown';
import Button from 'common/Button/Button';
import { InputBox } from 'common/FormField/formField';
import { validateId } from 'UtilityComponents/trainUtil';
import { ConditionalWrapper } from 'UtilityComponents/Util';
import DisplayContext, { Devices } from 'UtilityComponents/displayContext';
import Grid from 'common/Grid/Grid';

function TravellersForm({ closeModal, data, addNewPassenger, deletePassenger }) {
	const [formData, setFormData] = useState(cloneDeep(travelDetailForm));
	const [isDisabled, setDisabled] = useState(true);
	const displayName = useContext(DisplayContext).isMobile;

	const isEdit = data && data.name;

	const isMobile = displayName == Devices.mobile;

	const getOptionLabel = useCallback((item) => item.name, []);

	const getOptionValue = useCallback((item) => item.id, []);

	useEffect(() => {
		const fData = cloneDeep(formData);
		setValues(fData);
		setFormData(fData);
	}, []);

	const setValues = (fData) => {
		for (let i = 0; i < fData.length; i++) {
			const field = fData[i];
			if (Array.isArray(field)) {
				setValues(field);
			}

			if (field.name === 'govtIdType') {
				const idNoField = fData[1];
				idNoField.validation.custom = field.value.custom;
			}
			if (field.type === 'select' && data[field.name]) {
				field.selectedValue = { ...data[field.name] };
			}
			field.value = data[field.name];
		}
	};

	const updateData = (error, data) => {
		for (let i = 0; i < data.length; i++) {
			const field = data[i];
			if (Array.isArray(field)) {
				error = updateData(error, field);
			} else if (field.type !== 'label' && field.type !== 'notification' ) {
				if (((field.isMandatory && !field.value) || field.error) && (field.name !== 'govtIdType' && field.name !== 'govtIdNo')) {
					error = true;
				}

				if (field.name === 'govtIdType') {
					const idNoField = data[1];
					idNoField.validation.custom = field.value.custom;
					if (idNoField.value) {
						idNoField.error = validateId(idNoField.validation.custom, idNoField.value);
						error = error || !!idNoField.error;
					}
					// setFormData(cloneDeep(data));
				}
			}
		}
		return error;
	};

	const handleTextChange = ()=> {
		const err = updateData(false, formData);
		setDisabled(err);
	};

	const handleDropDownChange = (field) => (selectedVal) => {
		field.value = field.selectedValue = selectedVal;
		const data = cloneDeep(formData);
		const err = updateData(false, data);
		setDisabled(err);
		setFormData(data);
	};

	const addValues = (obj, fData) => {
		for (let i = 0; i < fData.length; i++) {
			const field = fData[i];
			if (Array.isArray(field)) {
				addValues(obj, field);
			} else if (field.type !== 'label' && field.type !== 'notification') {
				obj[field.name] = field.value;
			}
		}
	};

	const handler = () => {
		const obj = {};
		addValues(obj, formData);
		addNewPassenger(obj);
	};

	const placeholder = ({ label, isMandatory }) =>(
		<span>
			<span>{label}</span>
			{isMandatory &&	<span style={{ color: '#ff6544', marginLeft: '2px' }}>*</span>}
		</span>
	);

	const form = (field) => {
		const { type, heading, subHeading, bottomM } = field;
		switch (type ) {
			case 'select':
				return (
					<DropDown
						$width={field.width}
						field={field}
						placeholder={placeholder(field)}
						keepPlaceholder
						handleChange={handleDropDownChange(field)}
						getOptionLabel={getOptionLabel}
						getOptionValue={getOptionValue}
						disabled={false}
					/>
				);
			case 'email':
			case 'text':
			case 'number':
			case 'tel':
				return (
					<InputBox
						mobileView
						bottom_M={10}
						handleChange={handleTextChange}
						key={field.name}
						field={field}
					/>
				);
			case 'notification':
				return (
					<Notification>
						<b>Please carry age proof</b> for senior citizen verification !
					</Notification>
				);
			case 'label':
				return (
					<GenericDiv bottom_M='2'>
						<GenericP fsize='12px' color='#000' f_weight='900' bottom_M={bottomM}>
							{heading}
						</GenericP>
						{subHeading &&
							<GenericP fsize='12px'>
								{subHeading}
							</GenericP>}
					</GenericDiv>
				);
		}
	};

	const renderFields = (fields) => fields && fields.map((field) => {
		let arr = [];
		if (Array.isArray(field)) {
			field && field.forEach((f) => {
				arr.push(
					<Grid item xs={f.xs} lg={f.lg}>
						{form(f)}
					</Grid>
				);
			});
			return arr;
		} else {
			return (
				<Grid item xs={field.xs} lg={field.lg}>
					{form(field)}
				</Grid>
			);
		}
	});

	const onDeleteClick = () => {
		deletePassenger();
		closeModal();
	};

	const MobileTitle = (
		<FlexDiv justify='space-between' align='center' $width='80vw'>
			<GenericP fsize='18px' f_weight='bold'>Travellers Details</GenericP>
			{isEdit && (
			<div>
				<TrainIcon icon='delete' onClick={onDeleteClick} />
			</div>)}
		</FlexDiv>
	);
	return (
		<Modal
			close
			width='510px'
			isMobile={isMobile}
			Modaldata={{
				customClass: '',
				title: isMobile ? '' : 'Traveller Details',
				mobileTitle: MobileTitle
			}}
			handleModal={closeModal}>
			<ConditionalWrapper
				condition={isMobile}
				wrapper={(children) => (
					<CardView {...cardViewMobileProps}>
						{children}
					</CardView>
				)}>
				<Grid container justify='space-between' spacing={3}>
					{renderFields(formData)}
				</Grid>
				<GenericDiv top_M='20'>
					<Button
						btnTxt='ADD TRAVELLER'
						btnType='Flat'
						btnName='Primary'
						handleClick={handler}
						disabled={isDisabled}
					/>
				</GenericDiv>
			</ConditionalWrapper>
		</Modal>
	);
}

export default TravellersForm;
